module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-analytic-2.0f345a62.svg";